/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useCourses } from "../../context/CoursesContext";
import { enrollCourse } from "../../utils/api";
import API from "../../utils/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { slugify } from "../../data/courseExtras";
import "./Courses.css";

// CourseBanners
import AIML_Banner from "../../assets/Courses_Banner/AIML-banner.jpeg";
import AI_Banner from "../../assets/Courses_Banner/AI-banner.jpg";
import ML_AI_Banner from "../../assets/Courses_Banner/Machine-learning-AI.jpg";
import Generative_AI from "../../assets/Courses_Banner/Generative-AI.jpg";
import Agentic_AI from "../../assets/Courses_Banner/Agenetic-AI.jpg";
import FullStack_Banner from "../../assets/Courses_Banner/full-stack-banner.jpeg";
import Frontend_Banner from "../../assets/Courses_Banner/Frontend-Developments-banner.jpg";
import Backend_Banner from "../../assets/Courses_Banner/Backend-Developments-banner.jpg";
import MERN_Banner from "../../assets/Courses_Banner/MERN-Stack-banner.jpg";
import Java_Banner from "../../assets/Courses_Banner/Java-Fullstack-banner.jpg";
import C_Banner from "../../assets/Courses_Banner/C-banner.jpeg";
import C_Banner_JPG from "../../assets/Courses_Banner/C-banner.jpg";
import DATA_Analyst from "../../assets/Courses_Banner/DATA-Analyst-banner.jpg";
import DATA_Scientist from "../../assets/Courses_Banner/DATA-Analyst-banner2.jpg";
import DATA_Automation from "../../assets/Courses_Banner/DATA-Analyst-banner3.jpg";
import DATA_Science_AI from "../../assets/Courses_Banner/DATA-Analyst-banner4.jpg";
import DevOps_Banner from "../../assets/Courses_Banner/DevOps-banner.jpeg";
import Cloud_Solutions from "../../assets/Courses_Banner/Cloud-Solutions-banner.jpg";
import AWS_Cloud from "../../assets/Courses_Banner/AWS-Cloud-banner..jpg";
import DevOps_Engineer from "../../assets/Courses_Banner/DevOps-Engineer-banner.jpg";
import MS_Azure from "../../assets/Courses_Banner/MS-Cloud-Azure-banner..jpg";
import JavaBanner from "../../assets/Courses_Banner/Java-Development-banner.jpg";
import PythonBanner from "../../assets/Courses_Banner/Pyhton-banner.jpg";
import UI_UXbanner from "../../assets/Courses_Banner/UI_UX-banner.jpg";
import MobileApp_Banner from "../../assets/Courses_Banner/Mobile-app-banner.jpg";
import Digital_marketing from "../../assets/Courses_Banner/Digital-Marketing-banner.png";
import Video_editor from "../../assets/Courses_Banner/Video-editor-banner.jpg";

/* ─── Razorpay loader ─── */
const loadRazorpaySDK = () =>
  new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

/* ─── Meta ─── */
const HEADER_GRADIENTS = {
  green: "linear-gradient(135deg, #4ade80 0%, #bbf7d0 50%, #ffffff 100%)",
  purple: "linear-gradient(135deg, #ffd23f 0%, #ddd6fe 50%, #ffffff 100%)",
  amber: "linear-gradient(135deg, #fbbf24 0%, #fde68a 50%, #ffffff 100%)",
  sky: "linear-gradient(135deg, #ffd23f 0%, #ffd23f 50%, #ffffff 100%)",
};

const COURSE_META = [
  {
    keys: [
      "web",
      "full stack",
      "fullstack",
      "mern",
      "frontend",
      "backend",
      "java fullstack",
    ],
    icon: "lucide:code-2",
    bg: HEADER_GRADIENTS.green,
    iconColor: "#16a34a",
  },
  {
    keys: [
      "ai",
      "machine",
      "deep learning",
      "nlp",
      "automation",
      "ml",
      "generative",
      "agentic",
    ],
    icon: "lucide:brain-circuit",
    bg: HEADER_GRADIENTS.purple,
    iconColor: "#7c3aed",
  },
  {
    keys: [
      "data",
      "sql",
      "analytics",
      "data science",
      "data analyst",
      "data scientist",
    ],
    icon: "lucide:database",
    bg: HEADER_GRADIENTS.amber,
    iconColor: "#d97706",
  },
  {
    keys: ["cloud", "devops", "docker", "kubernetes", "aws", "azure"],
    icon: "lucide:cloud",
    bg: HEADER_GRADIENTS.sky,
    iconColor: "#ffd23f",
  },
];

const getCourseMeta = (title = "") => {
  const t = title.toLowerCase();
  return (
    COURSE_META.find(({ keys }) => keys.some((k) => t.includes(k))) || {
      icon: "lucide:laptop",
      bg: HEADER_GRADIENTS.sky,
      iconColor: "#E8A820",
    }
  );
};

/* ─── Smart image helper ─── */
const getFinalBanner = (course) => {
  if (course.image) return course.image;

  const title = (course.title || "").toLowerCase();

  if (
    title.includes("video") ||
    title.includes("editing") ||
    title.includes("content")
  )
    return Video_editor;
  if (
    title.includes("c/c++") ||
    title.includes("c++") ||
    title.includes("c programming") ||
    title.includes("c language")
  )
    return C_Banner_JPG;
  if (title.includes("python")) return PythonBanner;
  if (
    title.includes("java") &&
    !title.includes("fullstack") &&
    !title.includes("full stack")
  )
    return JavaBanner;
  if (title.includes("ui") || title.includes("ux") || title.includes("design"))
    return UI_UXbanner;
  if (title.includes("mobile") || title.includes("app"))
    return MobileApp_Banner;
  if (title.includes("digital") || title.includes("marketing"))
    return Digital_marketing;
  if (title.includes("devops")) return DevOps_Banner;
  if (title.includes("cloud")) return Cloud_Solutions;
  if (title.includes("data")) return DATA_Analyst;
  if (title.includes("ai") || title.includes("machine")) return AIML_Banner;

  return FullStack_Banner;
};

/* ─── Domain Courses ─── */
export const DOMAIN_COURSES = {
  "AI/ML": [
    {
      id: "ai-certified",
      title: "Certified Artificial Intelligence",
      duration: "12 Weeks",
      tools: ["Python", "TensorFlow", "PyTorch"],
      price: 8999,
      image: AI_Banner,
    },
    {
      id: "ai-ml-certified",
      title: "Certified AI + Machine Learning",
      duration: "14 Weeks",
      tools: ["Python", "Scikit-learn", "TensorFlow"],
      price: 12999,
      image: ML_AI_Banner,
    },
    {
      id: "gen-ai-certified",
      title: "Certified Generative AI",
      duration: "10 Weeks",
      tools: ["Python", "LangChain", "OpenAI"],
      price: 6999,
      image: Generative_AI,
    },
    {
      id: "agentic-ai-certified",
      title: "Certified Agentic AI",
      duration: "10 Weeks",
      tools: ["Python", "LangGraph", "CrewAI"],
      price: 6999,
      image: Agentic_AI,
    },
  ],
  "Full Stack": [
    {
      id: "frontend-certified",
      title: "Certified Frontend Development",
      duration: "10 Weeks",
      tools: ["HTML", "CSS", "JavaScript", "React"],
      price: 4999,
      image: Frontend_Banner,
    },
    {
      id: "backend-certified",
      title: "Certified Backend Development",
      duration: "12 Weeks",
      tools: ["Node.js", "Express", "MongoDB"],
      price: 4999,
      image: Backend_Banner,
    },
    {
      id: "mern-certified",
      title: "Certified MERN Stack Development",
      duration: "16 Weeks",
      tools: ["React", "Node.js", "MongoDB", "Express"],
      price: 8999,
      image: MERN_Banner,
    },
    {
      id: "java-fullstack-certified",
      title: "Certified Java Fullstack Development",
      duration: "16 Weeks",
      tools: ["Java", "Spring Boot", "React", "MySQL"],
      price: 8999,
      image: Java_Banner,
    },
  ],
  "Data Analyst": [
    {
      id: "data-analyst-certified",
      title: "Certified Data Analyst",
      duration: "12 Weeks",
      tools: ["Excel", "SQL", "Power BI", "Python"],
      price: 7999,
      image: DATA_Analyst,
    },
    {
      id: "data-scientist-certified",
      title: "Certified Data Scientist",
      duration: "16 Weeks",
      tools: ["Python", "SQL", "Machine Learning", "Tableau"],
      price: 8999,
      image: DATA_Scientist,
    },
    {
      id: "data-automation-certified",
      title: "Data Science & Automations",
      duration: "14 Weeks",
      tools: ["Python", "Pandas", "Selenium", "Airflow"],
      price: 9999,
      image: DATA_Automation,
    },
    {
      id: "data-ai-certified",
      title: "Data Science + AI",
      duration: "16 Weeks",
      tools: ["Python", "TensorFlow", "SQL", "Power BI"],
      price: 11999,
      image: DATA_Science_AI,
    },
  ],
  "DevOps & Cloud": [
    {
      id: "cloud-solutions",
      title: "Cloud Solutions & DevOps",
      duration: "12 Weeks",
      tools: ["AWS", "Docker", "Kubernetes", "Terraform"],
      price: 12999,
      image: Cloud_Solutions,
    },
    {
      id: "aws-certified",
      title: "Certified AWS Cloud Practitioner",
      duration: "8 Weeks",
      tools: ["AWS", "EC2", "S3", "Lambda"],
      price: 8999,
      image: AWS_Cloud,
    },
    {
      id: "devops-certified",
      title: "Certified DevOps Engineer",
      duration: "14 Weeks",
      tools: ["Docker", "Kubernetes", "Jenkins", "Git"],
      price: 9999,
      image: DevOps_Engineer,
    },
    {
      id: "azure-cloud",
      title: "Microsoft Azure Cloud Solutions",
      duration: "12 Weeks",
      tools: ["Azure", "ARM", "DevOps", "PowerShell"],
      price: 8999,
      image: MS_Azure,
    },
  ],
};

/* ══════════════════════════════════════════════════════════════
   EnrollModal
══════════════════════════════════════════════════════════════ */
export const EnrollModal = ({ course, onClose }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [paymentType, setPaymentType] = useState("full");
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [form, setForm] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
    college: user?.college || "",
    degree: "",
    year: user?.year || "",
  });

  const originalPrice = course.originalPrice || Math.round(course.price * 1.2);
  const offerPrice = course.price;
  const discount = Math.round(
    ((originalPrice - offerPrice) / originalPrice) * 100,
  );
  const couponDiscount = couponApplied ? Math.round(offerPrice * 0.1) : 0;
  const finalPrice = offerPrice - couponDiscount;
  const finalEmi1 = Math.ceil(finalPrice * 0.3);
  const payAmount = paymentType === "emi" ? finalEmi1 : finalPrice;

  const VALID_COUPONS = [
    "WEINTERN10",
    "INTERN10",
    "WELCOME10",
    "LAUNCH10",
    "STUDENT10",
  ];

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      toast.error("Please login");
      navigate("/login");
      return;
    }
    if (
      !form.name ||
      !form.email ||
      !form.phone ||
      !form.college ||
      !form.degree ||
      !form.year
    ) {
      toast.error("Please fill all fields");
      return;
    }
    const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY_ID;
    if (!RAZORPAY_KEY) {
      toast.error("Payment not configured");
      return;
    }
    setLoading(true);
    setStep(2);
    try {
      const enrollRes = await enrollCourse({
        ...form,
        courseName: course.title,
        coursePrice: course.price,
      });
      const enrollmentId = enrollRes.data.data._id;
      const sdkLoaded = await loadRazorpaySDK();
      if (!sdkLoaded) {
        toast.error("Payment gateway failed");
        setStep(1);
        setLoading(false);
        return;
      }
      const orderRes = await API.post("/payments/create-order", {
        amount: payAmount,
        enrollmentId,
        paymentType,
        emiInstallment: paymentType === "emi" ? 1 : null,
        couponApplied,
        couponCode: couponApplied ? couponCode : null,
        originalPrice: offerPrice,
        discountAmount: couponDiscount,
        finalPrice,
      });
      const order = orderRes.data.order;
      const rzp = new window.Razorpay({
        key: RAZORPAY_KEY,
        amount: order.amount,
        currency: "INR",
        name: "WeIntern",
        description: course.title,
        image: `${window.location.origin}/welogo.png`,
        order_id: order.id,
        handler: async (response) => {
          try {
            await API.post("/payments/verify", {
              ...response,
              enrollmentId,
              paymentType,
              emiInstallment: paymentType === "emi" ? 1 : null,
              amount: payAmount,
              couponApplied,
              couponCode: couponApplied ? couponCode : null,
              originalPrice: offerPrice,
              discountAmount: couponDiscount,
              finalPrice,
            });
            toast.success("Payment successful! You are now enrolled.");
            onClose();
          } catch {
            toast.error("Verification failed");
          }
        },
        prefill: { name: form.name, email: form.email, contact: form.phone },
        theme: { color: "#E8A820" },
        modal: {
          ondismiss: () => {
            toast("Cancelled", { icon: "ℹ️" });
            setStep(1);
            setLoading(false);
          },
        },
      });
      rzp.on("payment.failed", (r) => {
        toast.error(`Failed: ${r.error.description}`);
        setStep(1);
        setLoading(false);
      });
      rzp.open();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
      setStep(1);
      setLoading(false);
    }
  };

  const meta = getCourseMeta(course.title);

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && !loading && onClose()}
    >
      <div
        className="modal-box"
        style={{ position: "relative", maxWidth: "480px" }}
      >
        <button
          onClick={() => !loading && onClose()}
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "var(--muted)",
          }}
        >
          ×
        </button>

        <div className="enroll-header">
          <div
            className="enroll-emoji"
            style={{ color: meta.iconColor, background: meta.bg }}
          >
            <Icon icon={meta.icon} width={28} height={28} />
          </div>
          <div style={{ flex: 1 }}>
            <h3
              style={{ margin: 0, fontSize: "1.05rem", color: "var(--navy)" }}
            >
              {course.title}
            </h3>
            <div className="enroll-price-row">
              <span className="enroll-original-price">
                ₹{originalPrice.toLocaleString("en-IN")}
              </span>
              <span className="enroll-discount-badge">{discount}% OFF</span>
              <span className="enroll-offer-price">
                ₹{offerPrice.toLocaleString("en-IN")}
              </span>
            </div>
          </div>
        </div>

        {step === 1 && (
          <form onSubmit={handleSubmit}>
            <div className="enroll-form-grid">
              {[
                ["name", "Full Name", "text"],
                ["email", "Email", "email"],
                ["phone", "Phone", "tel"],
                ["college", "College", "text"],
              ].map(([n, p, t]) => (
                <div className="form-group" key={n}>
                  <label>{p} *</label>
                  <input
                    type={t}
                    name={n}
                    placeholder={p}
                    value={form[n]}
                    onChange={handleChange}
                    required
                  />
                </div>
              ))}
              <div className="form-group">
                <label>Degree *</label>
                <select
                  name="degree"
                  value={form.degree}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Degree</option>
                  {["BCA", "MCA", "B.Tech", "M.Tech", "BSc", "Other"].map(
                    (d) => (
                      <option key={d}>{d}</option>
                    ),
                  )}
                </select>
              </div>
              <div className="form-group">
                <label>Year *</label>
                <select
                  name="year"
                  value={form.year}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Year</option>
                  {["1st Year", "2nd Year", "3rd Year", "Final Year"].map(
                    (y) => (
                      <option key={y}>{y}</option>
                    ),
                  )}
                </select>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full enroll-pay-btn"
            >
              <Icon
                icon="lucide:lock"
                width={15}
                height={15}
                style={{ marginRight: "0.3rem" }}
              />
              Pay ₹{Number(finalPrice).toLocaleString("en-IN")} Now
            </button>
            <button
              type="button"
              className="btn btn-outline btn-full"
              onClick={onClose}
              style={{ marginTop: ".6rem" }}
            >
              Cancel
            </button>
          </form>
        )}

        {step === 2 && (
          <div className="enroll-processing">
            <div className="processing-spinner" />
            <h3>Opening Payment Gateway...</h3>
            <p>Please wait...</p>
          </div>
        )}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   Main Courses Component
══════════════════════════════════════════════════════════════ */
const Courses = () => {
  const [enrollCourseData, setEnrollCourseData] = useState(null);
  const [showAllOtherCourses, setShowAllOtherCourses] = useState(false);
  const { activeCourses } = useCourses();
  const { user } = useAuth();
  const navigate = useNavigate();

  const sections = [
    {
      key: "AI/ML",
      title: "AI / Machine Learning",
      icon: "lucide:brain-circuit",
    },
    {
      key: "Full Stack",
      title: "Full Stack Development",
      icon: "lucide:code-2",
    },
    {
      key: "Data Analyst",
      title: "Data Analyst & Science",
      icon: "lucide:bar-chart-2",
    },
    {
      key: "DevOps & Cloud",
      title: "DevOps & Cloud Solutions",
      icon: "lucide:cloud",
    },
  ];

  const mainKeys = [
    "ai",
    "machine",
    "deep learning",
    "nlp",
    "automation",
    "ml",
    "generative",
    "agentic",
    "web",
    "full stack",
    "fullstack",
    "mern",
    "frontend",
    "backend",
    "java fullstack",
    "data",
    "sql",
    "analytics",
    "data science",
    "data analyst",
    "data scientist",
    "cloud",
    "devops",
    "docker",
    "kubernetes",
    "aws",
    "azure",
  ];

  const otherCourses = (activeCourses || []).filter((c) => {
    const t = (c.title || "").toLowerCase();
    return !mainKeys.some((k) => t.includes(k));
  });

  // Show only first 4 courses initially
  const displayedOtherCourses = showAllOtherCourses ? otherCourses : otherCourses.slice(0, 4);
  const hasMoreCourses = otherCourses.length > 4;

  return (
    <section className="courses" id="courses">
      <div className="courses-container">
        {/* Page Header */}
        <div className="cs-page-header">
          <h2 className="cs-page-title">
            Explore Our <span>Career Programs</span>
          </h2>
          <p className="cs-page-subtitle">
            Choose your path. Learn industry-ready skills with certificates,
            free internships and placement support.
          </p>
        </div>

        {/* Main Domain Sections */}
        {sections.map((section) => (
          <div className="cs-domain-section" key={section.key}>
            <div className="cs-domain-header">
              <div className="cs-domain-icon">
                <Icon icon={section.icon} width={22} height={22} />
              </div>
              <h3 className="cs-domain-title">{section.title}</h3>
            </div>

            <div className="cs-cards-grid">
              {DOMAIN_COURSES[section.key].map((c) => {
                const meta = getCourseMeta(c.title);
                return (
                  <div
                    key={c.id}
                    className="cs-card"
                    onClick={() => navigate(`/courses/${slugify(c.title)}`)}
                  >
                    <div className="cs-card-image">
                      <img src={c.image} alt={c.title} loading="lazy" />
                    </div>
                    <div className="cs-card-content">
                      <div className="cs-card-provider">
                        <Icon icon={meta.icon} width={14} height={14} />
                        <span>WeIntern</span>
                      </div>
                      <h3 className="cs-card-title">{c.title}</h3>
                      <div className="cs-card-benefits">
                        <span className="cs-benefit-chip">
                          <Icon
                            icon="lucide:badge-check"
                            width={13}
                            height={13}
                          />
                          Certificates
                        </span>
                        <span className="cs-benefit-chip">
                          <Icon
                            icon="lucide:briefcase"
                            width={13}
                            height={13}
                          />
                          Free Internships
                        </span>
                        <span className="cs-benefit-chip">
                          <Icon icon="lucide:trophy" width={13} height={13} />
                          100% Placement
                        </span>
                      </div>

                      <button
                        className="cs-explore-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/courses/${slugify(c.title)}`);
                        }}
                      >
                        Explore Now
                        <Icon
                          icon="lucide:arrow-right"
                          width={15}
                          height={15}
                        />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Other Courses Section - Always visible with first 4 courses */}
        {otherCourses.length > 0 && (
          <div className="cs-domain-section cs-other-courses-section">
            <div className="cs-domain-header">
              <div className="cs-domain-icon">
                <Icon icon="lucide:layers" width={22} height={22} />
              </div>
              <h3 className="cs-domain-title">Other Courses</h3>
              {/* View More button in header */}
              {hasMoreCourses && (
                <button
                  className="cs-view-more-btn"
                  onClick={() => setShowAllOtherCourses(!showAllOtherCourses)}
                >
                  {showAllOtherCourses ? "Show Less" : "View More"}
                  <Icon 
                    icon={showAllOtherCourses ? "lucide:chevron-up" : "lucide:chevron-down"} 
                    width={16} 
                    height={16} 
                  />
                </button>
              )}
            </div>

            <div className="cs-cards-grid">
              {displayedOtherCourses.map((c) => {
                const meta = getCourseMeta(c.title);
                return (
                  <div
                    key={c.id || c.title}
                    className="cs-card"
                    onClick={() => navigate(`/courses/${slugify(c.title)}`)}
                  >
                    <div className="cs-card-image">
                      <img
                        src={getFinalBanner(c)}
                        alt={c.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="cs-card-content">
                      <div className="cs-card-provider">
                        <Icon icon={meta.icon} width={14} height={14} />
                        <span>WeIntern</span>
                      </div>
                      <h3 className="cs-card-title">{c.title}</h3>
                      <div className="cs-card-benefits">
                        <span className="cs-benefit-chip">
                          <Icon
                            icon="lucide:badge-check"
                            width={13}
                            height={13}
                          />
                          Certificates
                        </span>
                        <span className="cs-benefit-chip">
                          <Icon
                            icon="lucide:briefcase"
                            width={13}
                            height={13}
                          />
                          Free Internships
                        </span>
                        <span className="cs-benefit-chip">
                          <Icon icon="lucide:trophy" width={13} height={13} />
                          100% Placement
                        </span>
                      </div>

                      <button
                        className="cs-explore-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/courses/${slugify(c.title)}`);
                        }}
                      >
                        Explore Now
                        <Icon
                          icon="lucide:arrow-right"
                          width={15}
                          height={15}
                        />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Enroll Modal */}
      {enrollCourseData && (
        <EnrollModal
          course={enrollCourseData}
          onClose={() => setEnrollCourseData(null)}
        />
      )}
    </section>
  );
};

export default Courses;
